import React from 'react';

const SvgBi = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="BI_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="BI_svg__b" fill="#fff">
        <use xlinkHref="#BI_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#BI_svg__a" />
      <path fill="#E4233B" mask="url(#BI_svg__b)" d="M0 0h28v20H0z" />
      <path fill="#34CD4E" mask="url(#BI_svg__b)" d="M0 0l12 10L0 20z" />
      <path
        fill="#34CD4E"
        mask="url(#BI_svg__b)"
        transform="matrix(-1 0 0 1 44 0)"
        d="M16 0l12 10-12 10z"
      />
      <path
        d="M11.038 6.394A4.647 4.647 0 0 1 14 5.334c1.125 0 2.156.397 2.962 1.06l12.32-8.31 1.492 2.21-12.32 8.31a4.665 4.665 0 0 1 0 2.792l12.32 8.31-1.492 2.21-12.32-8.31A4.647 4.647 0 0 1 14 14.666a4.647 4.647 0 0 1-2.962-1.06l-12.32 8.31-1.492-2.21 12.32-8.31A4.665 4.665 0 0 1 9.333 10c0-.486.075-.955.213-1.396L-2.774.294l1.492-2.21 12.32 8.31z"
        fill="#FFF"
        mask="url(#BI_svg__b)"
      />
      <path
        d="M14 8.667l-.943.276.276-.943-.276-.943.943.276.943-.276-.276.943.276.943L14 8.667zM12 12l-.943.276.276-.943-.276-.942.943.276.943-.276-.276.942.276.943L12 12zm4 0l-.943.276.276-.943-.276-.942.943.276.943-.276-.276.942.276.943L16 12z"
        fill="#DF2239"
        mask="url(#BI_svg__b)"
      />
    </g>
  </svg>
);

export default SvgBi;
